<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar histórico
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col" style="width: 25%">Data e Hora</th>
      <th scope="col" style="width: 75%">Descrição</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaHistoricos; let idx = index">
      <td *ngIf="!item.editavel">{{item.data_historico | date: 'dd/MM/yyyy hh:mm':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{item.texto}}</td>

      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_historico" [(ngModel)]="entity.data_historico" inputStyleClass="form-control"
          dataType="date" [showTime]="true" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true"
          class="ui-calendar-small" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.texto" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="texto">
      </td>

      <td class="text-right" style="min-width: 130px;">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" #btnsEditar (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>